import React from 'react'
import { Bar } from 'react-chartjs-2'
import { toFont, toPadding } from 'chart.js/helpers'
import { sum } from '../../../../common/Math'
import I18n from 'i18n'
import { identity } from '../../../../common/Units'

const ActivitiesBar = props => {
  const total = props.total
  const options = {
    indexAxis: 'y',
    maintainAspectRatio: false,
    elements: {
      point: {
        radius: 25,
        hoverRadius: 35,
        pointStyle: 'rectRounded'
      }
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        // Disable the on-canvas tooltip
        enabled: false,
        callbacks: props.tooltipCallbacks,
        external: function ({ chart, tooltip: tooltipModel }) {
          // Tooltip Element
          let tooltipEl = document.getElementById('chartjs-tooltip')

          // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement('div')
            tooltipEl.id = 'chartjs-tooltip'
            tooltipEl.innerHTML = '<table></table>'
            tooltipEl.style.backgroundColor = '#FFFFFF'
            tooltipEl.style.borderColor = '#000000'
            tooltipEl.style.borderWidth = 'thin'
            tooltipEl.style.borderStyle = 'solid'
            document.body.appendChild(tooltipEl)
          }

          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = '0'
            return
          }

          // Set caret Position
          tooltipEl.classList.remove('above', 'below', 'no-transform')
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign)
          } else {
            tooltipEl.classList.add('no-transform')
          }

          // Set Text
          if (tooltipModel.body) {
            const titleLines = tooltipModel.title || []
            const bodyLines = tooltipModel.body.map(item => item.lines)

            let innerHtml = '<thead>'

            titleLines.forEach(function (title) {
              innerHtml += '<tr><th>' + title + '</th></tr>'
            })
            innerHtml += '</thead><tbody>'

            bodyLines.forEach(function (body, i) {
              const colors = tooltipModel.labelColors[i]
              let style = 'background:' + colors.backgroundColor
              style += '; border-color:' + colors.borderColor
              style += '; border-width: 2px'
              const span = '<span style="' + style + '"></span>'
              innerHtml += '<tr><td>' + span + body + '</td></tr>'
            })
            innerHtml += '</tbody>'

            const tableRoot = tooltipEl.querySelector('table')
            tableRoot.innerHTML = innerHtml
          }

          const position = chart.canvas.getBoundingClientRect()

          // Display, position, and set styles for font
          tooltipEl.style.opacity = '1'
          tooltipEl.style.position = 'absolute'
          tooltipEl.style.left = position.left + window.pageXOffset + 'px'
          tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px'
          const bodyFont = toFont(tooltipModel.options.bodyFont)
          const padding = toPadding(tooltipModel.options.padding)
          tooltipEl.style.fontFamily = bodyFont.family
          tooltipEl.style.fontSize = bodyFont.size + 'px'
          tooltipEl.style.fontStyle = bodyFont.style
          tooltipEl.style.padding = padding.top + 'px ' + padding.left + 'px'
          tooltipEl.style.pointerEvents = 'none'
        }
      }
    },
    scales: {
      x: {
        display: true,
        stacked: true,
        beginAtZero: true,
        suggestedMax: total,
        grid: {
          color: (context) => {
            if (!props.showAxes) return 'transparent'
            return context.tick?.value === 0 ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.1)'
          }
        },
        ticks: {
          color: props.showAxes ? '#666' : 'transparent',
          callback: props.xTickCallback || identity
        }
      },
      y: {
        display: false,
        stacked: true
      }
    }
  }

  const datasets = []
  for (let idx = 0; idx < props.values.length; idx++) {
    datasets.push(
      {
        label: props.labels[idx],
        fill: false,
        backgroundColor: props.backgroundColors[idx],
        borderSkipped: false,
        borderRadius: 5,
        borderColor: props.borderColors[idx],
        barPercentage: 1.0,
        categoryPercentage: 1.0,
        stack: props.id,
        data: [props.values[idx]],
        borderWidth: 1
      }
    )
  }
  const data = {
    labels: [props.title],
    datasets: datasets
  }

  const notEnoughData = (sum(props.values) === 0)

  return (
    <div className='row'>
      <div className='col s1 horizontal-bar-icon'>
        {props.children}
      </div>
      <div className='col s11 contains-horizontal-bar'>
        {notEnoughData && <em className='insufficient-data'>{I18n.t('components.dashboards.steps.summary.not_enough_data')}</em>}
        {!notEnoughData && <div className='horizontal-bar-chart'><Bar data={data} options={options} redraw /></div>}
      </div>
    </div>
  )
}

export default ActivitiesBar
